import React, { Component } from 'react';
import TransportsWADTable from './TransportsWADTable';


export class TransportsWADContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'transportsWaitingArrival' ?
          <TransportsWADTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default TransportsWADContent;


// WEBPACK FOOTER //
// ./src/components/Transports/WaitingArrival/TransportsWADContent.js